import { useApi } from './use-api-call';
import { CountryDTO } from './country-api';
export const useSearchRepresentativeApi = () =>
    useApi<{
        representatives: RepresentativeDTO[];
        countries: CountryDTO[];
        regions: Region[];
        allowEdit: boolean;
    }>('/representative/search-representative');

export const useGetRepresentativeApi = () =>
    useApi<{ representative: RepresentativeDTO; allowEdit: boolean }>(
        '/representative/get-representative/{id}'
    );

export const useSaveRepresentativeApi = () =>
    useApi<{ representative: RepresentativeDTO }>('/representative/save-representative');

export const useDeleteRepresentativeApi = () =>
    useApi('/representative/delete-representative/{id}');

export interface RepresentativeDTO {
    id?: number;
    title: string;
    countryId: string;
    regionId: string;
    contact: string;
    email: string;
    businessHoursWeekdays: string;
    businessHoursWeekend: string;
    services: string;
}

export type Region = {
    id: string;
    name: string;
    description: string;
};
